/** Shown on the sign-in page when the two-factor step has no live challenge any more. */
export const CHALLENGE_TIMED_OUT = 'Your sign-in attempt timed out. Please sign in again.';
